// const adminSections = {
//     main: { key: 'main', name: 'Main Options', },
//     website: { key: 'website', name: 'Website Options', },
//     extra: { key: 'extra', name: 'Extra Options', },
//     admin: { key: 'admin', name: 'Admin Options', },
//     // settings: { key: 'settings', name: 'Settings Options', },

// }
export function test(params) {
    return params

    // if (params == "") {

    // }
    // else {

    // }
}


const adminWidgets = {

    // Overview widget showing lastFollowUpResult (left) and contracts currentStatus (right)
    contractsOverview: {
        key: 'ContractsOverviewWidget',
        page: 'forms',
        frame: 'forms',
        col: '12',
        title: '{{lang}}Contracts Overview',
        permissionParent: 'admin.forms',
        fetchUrl: 'getRecords',
        
        postBody: { 
            frame: 'forms'
            // No applet filter - global for all applets
        },
    },

    // Widget for contracts status distribution (exactly like ProcessStatusWidget)
    contractsStatusDistribution: {
        key: 'ContractsStatusWidget',
        showOnlyHaveData: true,
        page: 'forms',
        frame: 'forms',
        col: '12',
        title: '{{lang}}Contracts Status Distribution',
        permissionParent: 'admin.contracts',
        fetchUrl: 'getRecords',
        postBody: { 
            frame: 'forms',
            'values.lastFollowUpResult': 'قرارداد'
            // No applet filter - global for all applets
        },
    },

    // Chart for contracts status (only those with values.lastFollowUpResult = 'قرارداد')
    // contractsStatusChart: {
    //     key: 'ContractsChartWidget',
       
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}Contracts Status Distribution',
    //     type: 'doughnut',
    //     // permissionParent: 'admin.contracts',
    //     postBody: { 
    //         'values.lastFollowUpResult': 'قرارداد'
    //         // No applet filter - global for all applets
    //     },
    // },

    // Chart for all status types (all values.lastFollowUpResult)
    // allStatusChart: {
    //     key: 'ContractsChartWidget',
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}All Status Distribution',
    //     type: 'doughnut',
    //     // permissionParent: 'admin.contracts',
    //     postBody: { 
    //         // No filter - shows all statuses
    //         // No applet filter - global for all applets
    //     },
    // },

    totalContracts: {
        key: 'TableWidget',
        page: 'forms',
        frame: 'forms',
        col: '6',
        title: '{{lang}}Recent Contracts',
        permissionParent: 'admin.contracts',
        fetchUrl: 'getRecords',
        postBody: { 
            frame: 'forms',
            'values.lastFollowUpResult': 'قرارداد'
            // No applet filter - global for all applets
        },
        sort: { uDate: -1 },
        populates: [
            { key: 'values.veterinarian', model: 'employees', select: ['name'] },
            { key: 'values.customer', model: 'employees', select: ['name'] },
        ],
        actions: {
            seeStatus: { key: 'seeStatus', label: '{{lang}}See Orders Status', color: '#fff', function: 'openStatusModal', permission: '' },
        },
        headers: [
            { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.veterinarian', type: 'SelectInput', information: { label: '{{lang}}Veterinarian', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customer', type: 'SelectInput', information: { label: '{{lang}}Customer', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        limit: 5,
    },
    totalForms: {
        key: 'TableWidget',
        page: 'forms',
        frame: 'forms',
        col: '6',
        title: '{{lang}}Recent Forms',
        permissionParent: 'admin.forms',
        fetchUrl: 'getRecords',
        postBody: { 
            frame: 'forms',
            // No applet filter - global for all applets
        },
        sort: { uDate: -1 },
        actions: {
            seeStatus: { key: 'seeStatus', label: '{{lang}}See Orders Status', color: '#fff', function: 'openStatusModal', permission: '' },
        },
        headers: [
            { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        limit: 5,
    },

    // Time-based report widget (combined with period selector)
    // timeBasedReport: {
    //     key: 'TimeBasedReportWidget',
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}Time Based Reports',
    //     type: 'doughnut',
    //     // permissionParent: 'admin.contracts',
    //     postBody: {
    //         // Date filter will be added based on selected period
    //     },
    // },

    // "mydocuments": {
    //     key: 'TableWidget',
    //     page: 'mydocuments',

    //     col: '4',
    //     title: '{{lang}}My Documents',
    //     headers: adminPages.mydocuments.headers,
    //     pages: adminPages.mydocuments.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.mydocuments',


    //     fetchUrl: 'getMyDocuments',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },
    // "activeDocument": {
    //     key: 'TableWidget',
    //     page: 'activeDocument',

    //     col: '4',
    //     title: '{{lang}}Active Documents',
    //     headers: adminPages.activeDocument.headers,
    //     pages: adminPages.activeDocument.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.activeDocument',


    //     fetchUrl: 'getActiveDocument',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },

    // "report": {
    //     key: 'ChartWidget',
    //     page: 'report',
    //     type: 'line',
    //     col: '4',
    //     title: '{{lang}}Deprecate Documents',
    //     headers: adminPages.report.headers,
    //     pages: adminPages.report.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.report',
    //     fetchUrl: 'homePageChartDocs',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },

    // "deprecateDocument": {
    //     key: 'TableWidget',
    //     page: 'deprecateDocument',

    //     col: '4',
    //     title: '{{lang}}Deprecate Documents',
    //     headers: adminPages.deprecateDocument.headers,
    //     pages: adminPages.deprecateDocument.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.deprecateDocument',
    //     fetchUrl: 'getDeprecateDocument',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },




    // "pendingEquipments": {
    //     key: 'TableWidget',
    //     page: 'tequipments',

    //     col: '12',
    //     title: 'Pending Equipments To Sell',
    //     headers: adminPages.equipments.headers,
    //     permissionParent: 'admin.equipments',

    //     fetchUrl: 'getEquipments',
    //     addUrl: 'addEquipment',
    //     editUrl: 'addEquipment',
    //     removeUrl: 'removeEquipment',
    //     postBody: { "active": { "$ne": '1' } },
    //     populate: ["category"],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },



    // "pendingPartners": {
    //     key: 'TableWidget',
    //     page: 'users',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.users.headers,
    //     permissionParent: 'admin.users',

    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingEnquiries": {
    //     key: 'TableWidget',
    //     page: 'enquiries',

    //     col: '12',
    //     title: 'Pending Enquiries',
    //     headers: adminPages.enquiries.headers,
    //     permissionParent: 'admin.enquiries',

    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     postBody: { "values.status": '0' },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "usersActivity": {
    //     key: 'TableWidget',
    //     page: 'logs',

    //     col: '12',
    //     title: 'Users activities',
    //     headers: adminPages.logs.headers,
    //     permissionParent: 'admin.logs',

    //     fetchUrl: 'getInbox',
    //     addUrl: 'addInbox',
    //     editUrl: 'addInbox',
    //     removeUrl: 'removeInbox',
    //     // postBody: { "values.status": 1 },
    //     actions: {
    //         // edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
    //     },

    // }





}



export { adminWidgets }


// // const adminSections = {
// //     main: { key: 'main', name: 'Main Options', },
// //     website: { key: 'website', name: 'Website Options', },
// //     extra: { key: 'extra', name: 'Extra Options', },
// //     admin: { key: 'admin', name: 'Admin Options', },
// //     // settings: { key: 'settings', name: 'Settings Options', },

// import { adminPages } from "./adminPages"

// // }

// const adminWidgets = {

//     // department: {
//     //     key: 'department',
//     //     title: 'دپارتمان',
//     //     description: 'لیست دپارتمان ها',
//     //     fetchUrl: 'getAllDepartment',
//     //     addUrl: 'postDepartment',
//     //     editUrl: 'postDepartment',
//     //     removeUrl: 'removeDepartment',
//     //     col: '12',
//     //     options: { noAddNew: true },
//     //     // helperKey: 'values',
//     //     pageType: 'tree',
//     //     parent: 'admin',
//     //     options: {},
//     //     // sort: { 'cDate': -1 },
//     //     // addNew: -1,
//     //     image: '/images/icons/house.png',
//     //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
//     //     headers: [
//     //       { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}title', required: true }, showMain: true, inExport: true },
//     //       // { col: '6', type: 'SelectInput', key: 'parent', showKey: 'title', information: { label: 'آیتم والد', address: 'getAllDepartment', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: 'یک مقدار را انتخاب کنید', required: false }, showMain: true },
//     //       { col: '6', type: 'MultiTreeSelectAddListing', key: 'parentItem', showKey: 'parentTitle', information: { label: 'آیتم والد', address: 'getAllDepartment', filter: {}, fields: { title: 'title', value: '_id', parent: 'parent' }, type: 'api', isSearchable: true, placeholder: 'یک مقدار را انتخاب کنید', required: false }, showMain: true },
//     //       { key: 'status', type: 'SelectInput', col: '6', information: { label: 'وضعیت', placeholder: 'وضعیت', type: 'local', items: [{ title: "فعال", value: 1 }, { title: 'غیر فعال', value: 2 },], required: true }, showMain: true },
//     //       { col: '6', key: 'technicalCode', type: 'NumberInput', information: { label: 'کد فنی', placeholder: 'کد فنی', required: false }, showMain: false },
//     //       { col: '6', key: 'priority', type: 'NumberInput', information: { label: 'اولویت', placeholder: 'اولویت', required: false }, showMain: false },
//     //       { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'توضیحات', placeholder: 'توضیحات', required: false }, showMain: false },
//     //     ],
//     //   },




//     // department: {
//     //     key: 'TableWidget',
//     //     page: 'department',
//     //     col: '12',
//     //     title: 'دپارتمان',
//     //     headers: adminPages.department.headers,
//     //     // pages: adminPages.department.pages,
//     //     permissionParent: 'admin.department',
//     //     fetchUrl: 'getAllDepartment',
//     //     addUrl: 'postDepartment',
//     //     editUrl: 'postDepartment',
//     //     removeUrl: 'removeDepartment',
//     //     // populate: ["category"],
//     //     postBody: { },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },



//     // "partnershipReq": {
//     //     key: 'TableWidget',
//     //     page: 'partnershipReq',

//     //     col: '12',
//     //     title: 'درخواست نمایندگی فروش',
//     //     headers: adminPages.partnershipReq.headers,
//     //     permissionParent: 'admin.partnershipReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "partnershipRepairReq": {
//     //     key: 'TableWidget',
//     //     page: 'partnershipRepairReq',

//     //     col: '12',
//     //     title: 'درخواست نمایندگی پس از فروش',
//     //     headers: adminPages.partnershipRepairReq.headers,
//     //     permissionParent: 'admin.partnershipRepairReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "fallowRepairReq": {
//     //     key: 'TableWidget',
//     //     page: 'fallowRepairReq',

//     //     col: '12',
//     //     title: 'درخواست پیگیری تعمیرات   ',
//     //     headers: adminPages.fallowRepairReq.headers,
//     //     permissionParent: 'admin.fallowRepairReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "imeiRequest": {
//     //     key: 'TableWidget',
//     //     page: 'imeiRequest',

//     //     col: '12',
//     //     title: ' درخواست imei ',
//     //     headers: adminPages.imeiRequest.headers,
//     //     permissionParent: 'admin.imeiRequest',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "complains": {
//     //     key: 'TableWidget',
//     //     page: 'complains',

//     //     col: '12',
//     //     title: 'شکایات   ',
//     //     headers: adminPages.complains.headers,
//     //     permissionParent: 'admin.complains',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "survey": {
//     //     key: 'TableWidget',
//     //     page: 'survey',

//     //     col: '12',
//     //     title: 'نظر سنجی   ',
//     //     headers: adminPages.survey.headers,
//     //     permissionParent: 'admin.survey',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },




//     // "pendingPartners": {
//     //     key: 'TableWidget',
//     //     page: 'questions',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.questions.headers,
//     //     permissionParent: 'admin.questions',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "pendingPartners2": {
//     //     key: 'TableWidget',
//     //     page: 'answers',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.answers.headers,
//     //     permissionParent: 'admin.answers',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "pendingPartners2": {
//     //     key: 'TableWidget',
//     //     page: 'contents',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.contents.headers,
//     //     permissionParent: 'admin.contents',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },



//     //     "pendingPartners2": {
//     //         key: 'TableWidget',
//     //         page: 'categories',

//     //         col: '12',
//     //         title: 'Pending Partners',
//     //         headers: adminPages.categories.headers,
//     //         permissionParent: 'admin.categories',
//     //         addUrl: 'addValue',
//     //         editUrl: 'addValue',
//     //         fetchUrl: 'getUsers',
//     //         addFetch: 'addUser',
//     //         removeUrl: 'removeUser',
//     //         postBody: { "values.status": 1 },
//     //         actions: {
//     //             edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //         },

//     //     },

//     // }
//     // "pendingEnquiries": {
//     //     key: 'TableWidget',
//     //     page: 'contact',

//     //     col: '12',
//     //     title: 'Pending Enquiries',
//     //     headers: adminPages.contact.headers,
//     //     permissionParent: 'admin.contact',

//     //     fetchUrl: 'getAll',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     removeUrl: 'removeValue',
//     //     postBody: { "values.status": '0' },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "usersActivity": {
//     //     key: 'TableWidget',
//     //     page: 'logs',

//     //     col: '12',
//     //     title: 'Users activities',
//     //     headers: adminPages.logs.headers,
//     //     permissionParent: 'admin.logs',

//     //     fetchUrl: 'getInbox',
//     //     addUrl: 'addInbox',
//     //     editUrl: 'addInbox',
//     //     removeUrl: 'removeInbox',
//     //     // postBody: { "values.status": 1 },
//     //     actions: {
//     //         // edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
//     //     },

//     // }





// }


// export { adminWidgets }
